export default __webpack_public_path__ + "static/House-Naked-View-04-84e0032f2dd839ad8a7029c13e1f90c1.webp";